class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
        var vari_for_gift =  $( "cart-drawer").attr( "data-is-avl-for-gift" );  
        var from_id =  $(this).find("button").attr("data-variant-id")
        console.log("from_id", from_id, "event-this", this )
        if (vari_for_gift.includes(from_id)) {
              console.log("Ture", this , from_id)  
              removegiftproaddtocart(this, from_id , 0);
              return
        }
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
       checkCartTotal();

      // var timeStamp = this.closest(".cart-item").getAttribute("timestamp");
      // console.log("timeStamp",timeStamp);
      // var lineItems = document.querySelectorAll(".cart-item.freeProduct");
      // if(lineItems){
      //   lineItems.forEach(function(cartItem){
      //     var freepdpTimestamp = cartItem.getAttribute('timestamp');
      //     if(timeStamp == freepdpTimestamp){
      //       cartItem.querySelector("cart-remove-button").click();
      //     }
      //   });
      // }

      var $this = this;
      var timeStamp = this.closest(".cart-item").getAttribute("timestamp");
      setTimeout(function() {
        removeallgifts($this, timeStamp , 0);
      }, 2500);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    // console.log("CartItems", this)
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
      // console.log("this.onCartUpdate", this)
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
// console.log("onChange-event", this);
    if(event.target.className != "selling_plan_allocation_btn" && event.target.className != "frq_high_btn"){
    console.log("True",this, event.target.dataset.quantityVariantId);
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
    }  

  }

  onCartUpdate() {
    console.log("onCartUpdate")
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) =>   {              
           response.text()             
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
         //  subscription();
         // frq_high_subscription();  
         // checkCartTotal();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }

    
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    // console.log("line",line ,"quantity",quantity   ,"name",name  ,"variantId", variantId )
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        // subscription(); 
        // frq_high_subscription();
        // checkCartTotal();      
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
function subscription (pro) {
    $('.wrp-sub-btn input').change(function() {
        if(this.checked) {
          console.log("checked false")
          var selling_id = $(this).attr("data-selling-id");
          var pro_var_id = $(this).attr("data-variant-id");
          var row_no = $(this).attr("data-row-no");
          var qunty_no = $(this).parents(".cart-item").find(".quantity__input").val();
           console.log("selling_id",selling_id, "pro_var_id",pro_var_id, "row_no",row_no,"qunty_no",qunty_no )
          

          //Ak custom code
          var freePdpJson = JSON.parse($(this).attr("freepdpjson"));
          var timeStamp = $(this).parents(".cart-item").attr('timestamp');
          var lineItems = document.querySelectorAll(".cart-item[timestamp='"+timeStamp+"']");
          const arr = [];
          const arr_line = []; 
          
          var updates = {
            updates: {}
          };

          if(lineItems){
            lineItems.forEach(function(cartItem){
              // var item_line_id = cartItem.querySelector('cart-remove-button').getAttribute('data-variant-id');
              var item_line_id = cartItem.querySelector('cart-remove-button').getAttribute('data-key');
                      
              arr_line.push(item_line_id);
            });
          }

          arr_line.forEach((lineId) => {
            //updates[lineId] = 0;  // Set quantity to 0 to remove the item
            updates['updates'][lineId] = 0;
          });
      
          //updates[lineId] = 0;  // Set quantity to 0 to remove the item
          updates['updates'][pro_var_id] = 0;
          console.log(updates);
          
          $.ajax({
            url: "/cart/update.js",
            type: "POST",
            data: updates,
            dataType: "json",
            success: function (response) {
              console.log('success remove')
              // if($('body').hasClass('template-cart')){
              //   location.reload();
              // }else{
              //   const this_cartDrawer = document.querySelector('cart-drawer');
              //   this_cartDrawer.refresh(true,response.item_count);
              // }
              add_products();
            },
            error: function(error){
              console.log('not  remove')
            }
          });

          function add_products(){
              if(freePdpJson){
                for (let i = freePdpJson.length - 1; i >= 0; i--) {
                  const item = freePdpJson[i];
                  // Push the formatted object to the array
                  arr.push({ id: item.product_id, quantity: 1, properties: { '_time_stamp': timeStamp,'_free_product':'yes' } });
                }
               if(arr){
                 console.log(arr);
                  var sections = ['cart-drawer', 'cart-icon-bubble'];
                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                                      items:arr,
                                      sections: sections
                                  }),
                  })
                  .then(response => response.json())
                  .then(response =>  {
                    // add_main_pro();
                    // document.querySelector(".product-form__submit").click();
                    // const cartDrawer = document.querySelector('cart-drawer');
                    // // return false;
                    // cartDrawer.classList.remove('is-empty');          
                    // cartDrawer.renderContents(response);
                    // pro_submit_btn.classList.remove('loading');
                    // pro_submit_btn.querySelector('.loading__spinner').classList.add('hidden');
      
                    // var time = document.querySelector('cart-drawer').getAttribute('data-timer');
                    // window.cart_limit = time * 60 * 1000;
                    console.log('hiii jj')
                    add_main_pro();
                  })
                }
            }else{
                add_main_pro();
            }
            
          }
          
              
            function add_main_pro(){
                 $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data : {
                  "id": pro_var_id,
                  "quantity": qunty_no,
                  'selling_plan': selling_id,
                  properties:{
                    '_time_stamp':timeStamp
                  }
                  },
                  dataType: 'json',
                  success: function(response) {   
  
                    // add_free_gift_also();
                    const this_cartDrawer = document.querySelector('cart-drawer');
                    this_cartDrawer.refresh(true);                
                  },
                  error: function(response) { 
                  console.log("error-add", response)              
                  } 
                
                });
            }
          
            //  $.ajax({
            //   type: 'POST',
            //   url: '/cart/change.js',
            //   data : {
            //     "id": pro_var_id,
            //     "quantity": qunty_no,
            //     "selling_plan" : selling_id
            //   },
            //   dataType: 'json',
            //   success: function(response) { 
            //      console.log("response-success",response)
            //     const this_cartDrawer = document.querySelector('cart-drawer');
            //     this_cartDrawer.refresh(true);                
            //   },
            //    error: function(response) { 
            //      console.log("error", response)              
            //   }             
            // });

          
        }else{
         // console.log("un-checked false")
          var pro_var_id = $(this).attr("data-variant-id");
          var row_no = $(this).attr("data-row-no");
          var qunty_no = $(this).parents(".cart-item").find(".quantity__input").val();          
          // console.log("pro_var_id",pro_var_id, "row_no",row_no,"qunty_no",qunty_no )
          $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data : {
                "id": pro_var_id,
                "quantity": qunty_no,
                'selling_plan': null
              },
              dataType: 'json',
              success: function(response) { 
                 // console.log("response-success",response)
                var cart_line = document.querySelector("cart-drawer-items");
                    cart_line.updateQuantity(row_no,qunty_no);
                
              },
               error: function(response) { 
                 console.log("error", response)              
              } 
            
            });
        }        
    });  
}
subscription();

function frq_high_subscription (pro) {
            $('.high-wrp-sub-btn input').change(function() {
            console.log("frq_high_subscription")
            var pro_var_id = $(this).attr("data-variant-id");
            var pro_last_var_id = $(this).attr("data-last-variant-id");
            var pro_last_selling_id = $(this).attr("data-last-selling-id");
            var row_no = $(this).attr("data-row-no");  
            var selling_id = $(this).attr("data-selling-id");
            var qunty_no = $(this).parents(".cart-item").find(".quantity__input").val(); 
            var timeStamp = $(this).parents(".cart-item").attr('timestamp');

          //Ak custom code     first remove gifts which connected     
          var freePdpJson = JSON.parse($(this).attr("freepdpjson"));
          var lineItems = document.querySelectorAll(".cart-item[timestamp='"+timeStamp+"']");
          const arr_line = []; 
          const arr = [];
    
          if(lineItems){
            lineItems.forEach(function(cartItem){
              // var item_line_id = cartItem.querySelector('cart-remove-button').getAttribute('data-variant-id');
              var item_line_id = cartItem.querySelector('cart-remove-button').getAttribute('data-key');
                      
              arr_line.push(item_line_id);
            });
          }

          var updates = {
            updates: {}
          };
      
          arr_line.forEach((lineId) => {
            //updates[lineId] = 0;  // Set quantity to 0 to remove the item
            updates['updates'][lineId] = 0;
          });

              console.log(updates)
    
          $.ajax({
            url: "/cart/update.js",
            type: "POST",
            data: updates,
            dataType: "json",
            success: function (response) {
              console.log('success remove')
              // if($('body').hasClass('template-cart')){
              //   location.reload();
              // }else{
              //   const this_cartDrawer = document.querySelector('cart-drawer');
              //   this_cartDrawer.refresh(true,response.item_count);
              // }
              add_last_line()
            },
            error: function(error){
              console.log('not  remove')
            }
          });
          //end Ak custom code
              
            // $.ajax({
            //     type: 'POST',
            //     url: '/cart/change.js',
            //     data : {
            //     "id": pro_var_id,
            //     "quantity": 0,
            //     'selling_plan': selling_id || null
            //     },
            //     dataType: 'json',
            //     success: function(response) { 
            //       // console.log("change", response)
            //        add_last_line()
            //     },
            //     error: function(response) { 
            //         console.log("error-change", response)              
            //     } 
            
            // });
            function add_last_line(){
              // check product for gift 
              console.log("add_last_line")
              var gift_pro_id = parseInt($("cart-drawer").attr("data-gift-pro-id"));
              jQuery.getJSON('/cart.js', function(cart) {
                 for (var i = 0; i < cart.items.length; i++) {
                if (cart.items[i].variant_id == gift_pro_id) {
                    console.log("gift-on-cart")
                    return true;
                }else{
                    var vari_for_gift =  $( "cart-drawer").attr( "data-is-avl-for-gift" );  
                    var from_id =  pro_last_var_id
                    if (vari_for_gift.includes(from_id)) {  
                          giftproaddtocart(this, from_id , pro_last_selling_id);                  
                    }
                }
              }
              return false;
              }); 

              
              //Ak custom code
              function add_main_pro(){
                 $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data : {
                  "id": pro_last_var_id,
                  "quantity": qunty_no,
                  'selling_plan': pro_last_selling_id || null,
                  properties:{
                    '_time_stamp':timeStamp
                  }
                  },
                  dataType: 'json',
                  success: function(response) {   
  
                    // add_free_gift_also();
                    const this_cartDrawer = document.querySelector('cart-drawer');
                    this_cartDrawer.refresh(true);                
                  },
                  error: function(response) { 
                  console.log("error-add", response)              
                  } 
                
                });
              }
              // var freePdpJson = JSON.parse(customBtn.getAttribute("freepdpjson"));
              if(freePdpJson){
                for (let i = freePdpJson.length - 1; i >= 0; i--) {
                  const item = freePdpJson[i];
                  // Push the formatted object to the array
                  arr.push({ id: item.product_id, quantity: 1, properties: { '_time_stamp': timeStamp,'_free_product':'yes' } });
                }

                  if(arr){
                    var sections = ['cart-drawer', 'cart-icon-bubble'];
                    fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
            							items:arr,
            							sections: sections
            						}),
                    })
                    .then(response => response.json())
                    .then(response =>  {
                      add_main_pro();
                      // document.querySelector(".product-form__submit").click();
                      // const cartDrawer = document.querySelector('cart-drawer');
                      // // return false;
                      // cartDrawer.classList.remove('is-empty');          
                      // cartDrawer.renderContents(response);
                      // pro_submit_btn.classList.remove('loading');
                      // pro_submit_btn.querySelector('.loading__spinner').classList.add('hidden');
        
                      // var time = document.querySelector('cart-drawer').getAttribute('data-timer');
                      // window.cart_limit = time * 60 * 1000;
                    })
                  }else{
                    add_main_pro();
                  }
              }else{
                add_main_pro();
              }
              //End Ak custom code
              
              
        }
   });  
  }
frq_high_subscription();

// Function to add product to cart
function addProductToCart(productId) {
              $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data : {
              "id": productId,
              "quantity": 1
              },
              dataType: 'json',
              success: function(response) {       
                const this_cartDrawer = document.querySelector('cart-drawer');
                this_cartDrawer.refresh(true);                
              },
              error: function(response) { 
              console.log("error-add", response)              
              } 
              
              });
}

// Function to remove product from cart
function removeProductFromCart(lineItemId) {
              $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data : {
              "id": lineItemId,
              "quantity": 0
              },
              dataType: 'json',
              success: function(response) {       
                const this_cartDrawer = document.querySelector('cart-drawer');
                this_cartDrawer.refresh(true,response.item_count);                
              },
              error: function(response) { 
              console.log("error-add", response)              
              }               
              });
}

// Function to check if product is already in cart
function isProductInCart(productId, cart) {
    for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id == productId) {
            return true;
        }
    }
    return false;
}

// Function to check cart total and add/remove product accordingly
function checkCartTotal() {
console.log("checkCartTotal")
    jQuery.getJSON('/cart.js', function(cart) {
console.log("cart", cart, cart.total_price)
        var cartTotal = cart.total_price / 100; 
        var gift_pro_amount =  parseInt($("cart-drawer").attr("data-free-pro-amount")) / 100;
        var productId = parseInt($("cart-drawer").attr("data-gift-pro-id"));
        var lineItemId = null;

        // Check if gift product is already in cart
        var isGiftProductInCart = isProductInCart(productId, cart);
        console.log("isGiftProductInCart", isGiftProductInCart)
        // Add or remove gift product based on cart total
        if (cartTotal >= gift_pro_amount && !isGiftProductInCart) {
            addProductToCart(productId);
        } else if (cartTotal < gift_pro_amount && isGiftProductInCart) {
            for (var i = 0; i < cart.items.length; i++) {
                if (cart.items[i].variant_id == productId) {
                    console.log("productId-gift", productId)
                    removeProductFromCart(cart.items[i].id);
                    break;
                }
            }
        }
    });
}
function giftproaddtocart(ele, itemvarinat, pro_sell_id) {
            var gift_pro_id = parseInt($("cart-drawer").attr("data-gift-pro-id"));
            var current_id =  parseInt($(ele).find("[name='id']").attr("value")) || parseInt(itemvarinat) ;
            var current_selling_id =  parseInt($(ele).find("[name='selling_plan']").attr("value")) || parseInt(pro_sell_id)  ||  null;
             console.log("gift_pro_id", gift_pro_id,"current_id", current_id, "current_selling_id", current_selling_id )
              let formData = {
               'items': [{
                'id': gift_pro_id,
                'quantity': 1 ,
                'selling_plan': null 
                },{
                'id': current_id,
                'quantity': 1,
                'selling_plan': current_selling_id
                }]
              };

              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data : formData,
                dataType: 'json',
                success: function(response) { 
                  const this_cartDrawer = document.querySelector('cart-drawer');
                  this_cartDrawer.refresh(true);

                },
                error: function(response) { 
                    console.log("error", response)              
                } 
            
            });
  
}
function removegiftproaddtocart(ele, itemvarinat ,giftqty ) {
            var gift_pro_id = parseInt($("cart-drawer").attr("data-gift-pro-id"));
            var current_id =  parseInt($(ele).find("[name='id']").attr("value")) || parseInt(itemvarinat) ;
            var current_selling_id =  parseInt($(ele).find("[name='selling_plan']").attr("value"))  ||  null;
            let formData = {
              'updates': {
                [gift_pro_id]: 0, 
                [current_id]: 0             
              }
            };            
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: formData,
              dataType: 'json',
              success: function(response) {
                console.log("response", response);
                const this_cartDrawer = document.querySelector('cart-drawer');
                this_cartDrawer.refresh(true,response.item_count);
              },
              error: function(response) {
                console.log("error", response);
              }
            });  
}

function removeallgifts(ele, timeStamp , giftqty){
        console.log('hii',timeStamp);
      var timeStamp = timeStamp;
      var lineItems = document.querySelectorAll(".cart-item[timestamp='"+timeStamp+"']");
      const arr_line = []; 
      const arr = [];

      if(lineItems){
        lineItems.forEach(function(cartItem){
          // var item_line_id = cartItem.querySelector('cart-remove-button').getAttribute('data-variant-id');
          var item_line_id = cartItem.querySelector('cart-remove-button').getAttribute('data-key');
                  
          arr_line.push(item_line_id);
        });
      }

      var updates = {
        updates: {}
      };
  
      arr_line.forEach((lineId) => {
        //updates[lineId] = 0;  // Set quantity to 0 to remove the item
        updates['updates'][lineId] = 0;
      });

      $.ajax({
        url: "/cart/update.js",
        type: "POST",
        data: updates,
        dataType: "json",
        success: function (response) {

          if($('body').hasClass('template-cart')){
            location.reload();
          }else{
            const this_cartDrawer = document.querySelector('cart-drawer');
            this_cartDrawer.refresh(true,response.item_count);
          }
        },
        error: function(error){
        }
      });
}



 //Ak custom code
function remove_shipping_protection(){   
  if($('.shipping-protection #shipping-protection-switch-input').length > 0){
    var pro_var_id = $('.shipping-protection #shipping-protection-switch-input').val();
      jQuery.getJSON('/cart.js', function(cart) {
        let cartData = cart.items;
        if(cartData.length == 1){
          for(var i=0;i<cartData.length;i++){
            if(cartData[i].id == pro_var_id){
                var updates = {
                  updates: {}
                };

                updates['updates'][pro_var_id] = 0;

                $.ajax({
                  url: "/cart/update.js",
                  type: "POST",
                  data: updates,
                  dataType: "json",
                  success: function (response) {
                    console.log('success remove')
                    if($('body').hasClass('template-cart')){
                      location.reload();
                    }else{
                      const this_cartDrawer = document.querySelector('cart-drawer');
                      this_cartDrawer.refresh(true,response.item_count);
                    }
                  },
                  error: function(error){
                    console.log('not  remove')
                  }
                });

            }
          }
        }
      });
  }
}
//End Ak custom code




